export function shouldOpenPublicTwin(twin, hasSession) {
  if (twin?.isDemo) return false;
  if (!hasSession) return true;
  return twin?.association === "public";
}
